import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout } from 'antd';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/Home';
import AboutPage from './pages/About';
import ArchivePage from './pages/Archive';
import AuthPage from './pages/Auth';
import PostDetailPage from './pages/PostDetail';
import WritePostPage from './pages/WritePost';
import NotFoundPage from './pages/NotFound';
import './App.css';

const { Content } = Layout;

function App() {
  return (
    <Router>
      <Layout className="app-layout">
        <Header />
        <Content className="app-content">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/archive" element={<ArchivePage />} />
            <Route path="/auth" element={<AuthPage />} />
            <Route path="/post/:id" element={<PostDetailPage />} />
            <Route path="/write" element={<WritePostPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Content>
        <Footer />
      </Layout>
    </Router>
  );
}

export default App;